import React, { useMemo, memo } from 'react';
import PieChart from './PieChart';
import { FaLaptop, FaMobileAlt, FaTabletAlt } from 'react-icons/fa';
import { COMPLIANCE_COLORS, colorsForVersions } from '../theme/jspColors';

const PLATFORM_ICONS = {
  macos: FaLaptop,
  ios: FaMobileAlt,
  ipados: FaTabletAlt
};

const PlatformIcon = memo(({ platformType }) => {
  const IconComponent = PLATFORM_ICONS[platformType];
  return IconComponent ? <IconComponent /> : null;
});

const DashboardCard = ({ title, data, type, platformType }) => {
  const chartData = useMemo(() => {
    if (type === 'boolean' || type === 'profileInstalled') {
      return {
        labels: ['true', 'false'],
        datasets: [{
          label: type === 'profileInstalled' ? `profileInstalledFor${platformType}` : 'compliant',
          data: [data.true, data.false],
          backgroundColor: COMPLIANCE_COLORS,
          hoverOffset: 1,
        }],
      };
    }

    const labels = data.map((d) => d.version);
    return {
      labels,
      datasets: [{
        label: 'version',
        platformType,
        data: data.map((d) => d.count),
        backgroundColor: colorsForVersions(labels),
        hoverOffset: 1,
      }],
    };
  }, [data, type, platformType]);

  return (
    <div className="card dashboardCard">
      <div className="card-body">
        <PieChart title={title} data={chartData} />
        <div className="position-absolute bottom-0 end-0 platformMargins">
          <PlatformIcon platformType={platformType} />
        </div>
      </div>
    </div>
  );
};

export default memo(DashboardCard);
